/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import { ObservableQuery } from "@apollo/client";
import styled from "styled-components";
import { theme } from "@nordcloud/gnui";
import { CustomerBasic } from "~/generated/graphql";
import { PopoverControls } from "~/components";
import { DeleteCustomer } from "~/views/customers/Actions/DeleteCustomer/DeleteCustomer";
import { CustomerForm } from "~/views/customers/components/Form/CustomerForm";

const StyledButtonWrapper = styled.div`
  display: flex;
  gap: ${theme.spacing.spacing04};
  justify-content: flex-end;
`;

type Props = {
  customer: CustomerBasic;
  refetch: ObservableQuery["refetch"];
};

export function Actions({ customer, refetch }: Props) {
  const [isEditCustomerSidebarOpen, setIsEditCustomerSidebarOpen] =
    React.useState(false);
  const [isDeleteCustomerModalOpen, setIsDeleteCustomerModalOpen] =
    React.useState(false);

  return (
    <>
      <StyledButtonWrapper>
        <PopoverControls
          size="small"
          items={[
            {
              label: "Edit Customer",
              onClick: () => setIsEditCustomerSidebarOpen(true),
            },
            {
              label: "Delete Customer",
              onClick: () => setIsDeleteCustomerModalOpen(true),
            },
          ]}
          disabled={false}
        />
      </StyledButtonWrapper>
      <DeleteCustomer
        customerId={customer.id}
        customerName={customer.name}
        isDeleteCustomerModalOpen={isDeleteCustomerModalOpen}
        closeModal={() => setIsDeleteCustomerModalOpen(false)}
        onSuccess={() => refetch()}
      />
      <CustomerForm
        refetch={refetch}
        customer={customer}
        isSidebarOpen={isEditCustomerSidebarOpen}
        setIsSidebarOpen={() => setIsEditCustomerSidebarOpen(false)}
      />
    </>
  );
}
